import translationMessages from 'locale';
import { defaultLocale } from './constants';
import getInitialLocale from './getInitialLocale';

const t = (key) => {
  const locale = getInitialLocale();

  if (!translationMessages[locale][key]) {
    // eslint-disable-next-line no-console
    console.warn(`Translation '${key}' for locale '${locale}' not found.`);
  }

  return translationMessages[locale][key] || translationMessages[defaultLocale][key] || '';
};

export default t;
